// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/training-education.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand colors */
:root {
  --ace-dark: #0a3c2f;
  --ace-green: #007c4f;
  --ace-yellow: #ffd600;
  --ink: #0f172a;
  --muted: #334155;
  --card: rgba(255, 255, 255, 0.92);
}

/* === Page Background (keep as-is) === */
.training-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* HERO overlay wrapper */
.training-hero {
  width: 100%;
  flex: 1 1;
  padding: 60px 0 70px;

  /* clean readability overlay */
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.76) 0%,
    rgba(255, 255, 255, 0.84) 45%,
    rgba(255, 255, 255, 0.88) 100%
  );
}

/* Main content wrapper */
.training-content-wrapper {
  max-width: 1200px;
  width: 92%;
  margin: 110px auto 0 auto;
  border-radius: 18px;
  padding: 54px 46px;
  text-align: center;
}

/* HERO TEXT (same look as services banner you liked) */
.training-kicker {
  margin: 0 0 10px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(10, 60, 47, 0.85);
  font-size: 12px;
}

.training-title {
  font-size: 2.75rem;
  font-weight: 900;
  margin: 0 0 12px;
  line-height: 1.1;
}

.training-title-dark {
  color: var(--ace-dark);
}

.training-title-green {
  color: var(--ace-green);
}

.training-underline {
  width: 150px;
  height: 6px;
  margin: 16px auto 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--ace-green), var(--ace-yellow));
}

.training-subtitle {
  font-size: 1.05rem;
  color: var(--muted);
  margin: 0 auto 46px;
  max-width: 820px;
  line-height: 1.7;
}

/* === Training Grid === */
.training-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 22px;
}

/* === Training Cards (redesigned) === */
.training-card {
  background: var(--card);
  border-radius: 16px;
  padding: 26px 24px;
  text-align: left;
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.12);

  /* Required left border */
  border-left: 8px solid var(--ace-dark);

  transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
}

.training-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.16);
}

/* Card text */
.training-card-title {
  margin: 0 0 10px;
  font-size: 1.15rem;
  font-weight: 900;
  color: var(--ace-green);
}

.training-card-desc {
  margin: 0 0 18px;
  font-size: 0.98rem;
  color: #0b1220;
  line-height: 1.65;
}

/* CTA pill (uses your button colors) */
.training-card-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 900;
  font-size: 0.95rem;
  padding: 10px 14px;
  border-radius: 999px;
  background: var(--ace-green);
  color: #fff;
  box-shadow: 0 10px 18px rgba(0, 124, 79, 0.18);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.training-card:hover .training-card-cta {
  transform: translateY(-1px);
  box-shadow: 0 12px 20px rgba(0, 124, 79, 0.22);
}

/* Coming soon state */
.training-card.is-disabled {
  opacity: 0.72;
}

.training-card-cta.disabled {
  background: var(--ace-yellow);
  color: #111827;
  box-shadow: 0 10px 18px rgba(255, 214, 0, 0.18);
}

/* Responsive */
@media (max-width: 992px) {
  .training-content-wrapper {
    padding: 40px 22px;
    margin-top: 95px;
    width: 94%;
  }

  .training-title {
    font-size: 2.2rem;
  }

  .training-subtitle {
    font-size: 1rem;
    margin-bottom: 34px;
  }
}

@media (max-width: 768px) {
  .training-content-wrapper {
    margin-top: 85px;
  }

  .training-title {
    font-size: 1.85rem;
  }

  .training-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TrainingEducation/TrainingEducation.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,yCAAyC;AACzC;EACE,yDAA+D;EAC/D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,SAAO;EACP,oBAAoB;;EAEpB,8BAA8B;EAC9B;;;;;GAKC;AACH;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;;EAE3C,yBAAyB;EACzB,sCAAsC;;EAEtC,8EAA8E;AAChF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,WAAW;EACX,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Brand colors */\n:root {\n  --ace-dark: #0a3c2f;\n  --ace-green: #007c4f;\n  --ace-yellow: #ffd600;\n  --ink: #0f172a;\n  --muted: #334155;\n  --card: rgba(255, 255, 255, 0.92);\n}\n\n/* === Page Background (keep as-is) === */\n.training-page {\n  background-image: url(\"../../../public/training-education.jpg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n}\n\n/* HERO overlay wrapper */\n.training-hero {\n  width: 100%;\n  flex: 1;\n  padding: 60px 0 70px;\n\n  /* clean readability overlay */\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.76) 0%,\n    rgba(255, 255, 255, 0.84) 45%,\n    rgba(255, 255, 255, 0.88) 100%\n  );\n}\n\n/* Main content wrapper */\n.training-content-wrapper {\n  max-width: 1200px;\n  width: 92%;\n  margin: 110px auto 0 auto;\n  border-radius: 18px;\n  padding: 54px 46px;\n  text-align: center;\n}\n\n/* HERO TEXT (same look as services banner you liked) */\n.training-kicker {\n  margin: 0 0 10px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: rgba(10, 60, 47, 0.85);\n  font-size: 12px;\n}\n\n.training-title {\n  font-size: 2.75rem;\n  font-weight: 900;\n  margin: 0 0 12px;\n  line-height: 1.1;\n}\n\n.training-title-dark {\n  color: var(--ace-dark);\n}\n\n.training-title-green {\n  color: var(--ace-green);\n}\n\n.training-underline {\n  width: 150px;\n  height: 6px;\n  margin: 16px auto 18px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--ace-green), var(--ace-yellow));\n}\n\n.training-subtitle {\n  font-size: 1.05rem;\n  color: var(--muted);\n  margin: 0 auto 46px;\n  max-width: 820px;\n  line-height: 1.7;\n}\n\n/* === Training Grid === */\n.training-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 22px;\n}\n\n/* === Training Cards (redesigned) === */\n.training-card {\n  background: var(--card);\n  border-radius: 16px;\n  padding: 26px 24px;\n  text-align: left;\n  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.12);\n\n  /* Required left border */\n  border-left: 8px solid var(--ace-dark);\n\n  transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;\n}\n\n.training-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.16);\n}\n\n/* Card text */\n.training-card-title {\n  margin: 0 0 10px;\n  font-size: 1.15rem;\n  font-weight: 900;\n  color: var(--ace-green);\n}\n\n.training-card-desc {\n  margin: 0 0 18px;\n  font-size: 0.98rem;\n  color: #0b1220;\n  line-height: 1.65;\n}\n\n/* CTA pill (uses your button colors) */\n.training-card-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 900;\n  font-size: 0.95rem;\n  padding: 10px 14px;\n  border-radius: 999px;\n  background: var(--ace-green);\n  color: #fff;\n  box-shadow: 0 10px 18px rgba(0, 124, 79, 0.18);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.training-card:hover .training-card-cta {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 20px rgba(0, 124, 79, 0.22);\n}\n\n/* Coming soon state */\n.training-card.is-disabled {\n  opacity: 0.72;\n}\n\n.training-card-cta.disabled {\n  background: var(--ace-yellow);\n  color: #111827;\n  box-shadow: 0 10px 18px rgba(255, 214, 0, 0.18);\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .training-content-wrapper {\n    padding: 40px 22px;\n    margin-top: 95px;\n    width: 94%;\n  }\n\n  .training-title {\n    font-size: 2.2rem;\n  }\n\n  .training-subtitle {\n    font-size: 1rem;\n    margin-bottom: 34px;\n  }\n}\n\n@media (max-width: 768px) {\n  .training-content-wrapper {\n    margin-top: 85px;\n  }\n\n  .training-title {\n    font-size: 1.85rem;\n  }\n\n  .training-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
